import { useState } from "react";
import { ReactSVG } from "react-svg";
import { useTranslate } from "helpers";
import { VehicleBasicInfoProps } from "../types";
import { MilageEditModal } from "./MilageEditModal";

const VehicleBasicInfo: React.FC<VehicleBasicInfoProps> = ({ fleetVehicleDetail, onMileageUpdate }) => {
    const { t } = useTranslate();
    const [showMileageModal, setShowMileageModal] = useState(false);

    const handleMileageClick = () => {
        setShowMileageModal(true);
    };

    const handleMileageSuccess = (newMileage: number) => {
        onMileageUpdate?.(newMileage);
    };

    return (
        <>
            <div className="border-b border-slate-200 pt-4 px-4">
                <div className="text-sm font-bold text-slate-600 mb-3">
                    {t("admin.fleet.vehicle.detail.info.basic")}
                </div>
                <div className="grid grid-cols-4 mb-3 gap-3">
                    <div
                        className="relative border border-slate-200 bg-slate-50 p-3 rounded-sm  min-h-[70px] cursor-pointer hover:border-sky-300 transition-colors"
                        onClick={handleMileageClick}
                    >
                        <ReactSVG
                            src="/media/icons/edit.svg"
                            className="absolute top-2 right-2 [&_svg]:w-3.5 [&_svg]:h-3.5 [&_path]:stroke-slate-500 hover:[&_path]:stroke-sky-500 [&_path]:transition-colors" />
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.kmtraveled")}
                        </div>
                        <div className="text-md font-medium truncate text-sky-600 hover:text-sky-700">
                            {fleetVehicleDetail.kmTraveled && (`${fleetVehicleDetail.kmTraveled} km`)}
                        </div>
                    </div>
                    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.vehicletype.fueltype.name")}
                        </div>
                        <div className="text-md font-medium text-slate-800 truncate">
                            {fleetVehicleDetail?.vehicleType?.fuelType?.name}
                        </div>
                    </div>
                    <div className="flex">
                        <div className="border border-slate-200 bg-slate-50 p-3  min-h-[70px] rounded-tl-sm rounded-bl-sm flex-1">
                            <div className="text-sm text-slate-600">
                                {t("admin.fleet.vehicle.detail.info.vehicletype.maximumpowerkw")}
                            </div>
                            <div className="text-md font-medium text-slate-800 truncate">
                                {fleetVehicleDetail.kw} kw
                            </div>
                        </div>
                        <div className="border border-slate-200 bg-slate-50 p-3  min-h-[70px] mx-[-1px] flex-1">
                            <div className="text-sm text-slate-600">
                                {t("admin.fleet.vehicle.detail.info.vehicletype.maximumpowerhp")}
                            </div>
                            <div className="text-md font-medium text-slate-800 truncate">
                                {fleetVehicleDetail.hp} ks
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <MilageEditModal
                show={showMileageModal}
                onClose={() => setShowMileageModal(false)}
                onSuccess={handleMileageSuccess}
                vehicleId={fleetVehicleDetail.id ?? ""}
                currentMileage={fleetVehicleDetail.kmTraveled}
            />
        </>
    );
};

export default VehicleBasicInfo;
